import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSettings } from '@xemplo/xemplo-app-settings';

import { useAuth } from '../hooks/use-auth';

export const requireAuth =
  <P extends object>(WrappedComponent: React.ComponentType<P>, shouldNavigate = true) =>
  (props: P) => {
    const { hasTokenHandover } = useAppSettings();
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      if (!hasTokenHandover && !isAuthenticated && shouldNavigate) {
        navigate('/login', { replace: true });
      }
    }, [hasTokenHandover, isAuthenticated, navigate, shouldNavigate]);

    if (hasTokenHandover || isAuthenticated) {
      return <WrappedComponent {...(props as P)} />;
    }

    return null;
  };

export default requireAuth;
